import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <>
      <Header />
      <main className="pt-36 sm:pt-40 pb-20 min-h-screen bg-[#FAFAFA]" data-testid="payment-cancel-page">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="bg-white rounded-3xl border border-black/8 p-10">
            <XCircle size={64} className="text-[#FFDCA8] mx-auto" />
            <h1 className="display mt-5 text-3xl text-[#0A1128]">Paiement annulé</h1>
            <p className="mt-3 text-[#475569]">Pas de souci ! Vous pouvez réessayer ou choisir un autre format de RDV.</p>
            <div className="mt-6 flex gap-3 justify-center">
              <Link to="/rendez-vous" className="px-6 py-3 rounded-full bg-[#0A1128] text-white font-semibold">Reprendre la réservation</Link>
              <Link to="/" className="px-6 py-3 rounded-full bg-white border border-black/10 text-[#0A1128] font-semibold">Accueil</Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
